import AiAskBarRightActionsDefault from "./AiAskBarRightActionsDefault";
import AiAskBarRightActionsEmailReply from "./AiAskBarRightActionsEmailReply";

export default function AiAskBarRightActionsComposerBranch({
  vm,
  actions,
  onDiscard,
  sendDisabled,
  onVoiceToggle,
  voiceActive,
}) {
  if (vm.isEmailReply) {
    return (
      <AiAskBarRightActionsEmailReply
        attachments={vm.attachments}
        handleOpenFilePicker={actions.handleOpenFilePicker}
        handleSend={actions.handleSend}
        sendDisabled={sendDisabled}
        sendIsActive={vm.sendIsActive}
        isSendPulsing={vm.isSendPulsing}
        onDiscard={onDiscard}
      />
    );
  }
  return (
    <AiAskBarRightActionsDefault
      handleSend={actions.handleSend}
      sendDisabled={sendDisabled}
      sendIsActive={vm.sendIsActive}
      isSendPulsing={vm.isSendPulsing}
      onVoiceToggle={onVoiceToggle}
      voiceActive={voiceActive}
      isGenerating={vm.isGenerating}
      onStopGenerating={vm.onStopGenerating}
    />
  );
}
